import { newPath } from "./newPath";

export const pathWithBreadcrumb = (props: {breadcrumb_history: {name: string, url: string }[], current_name:string | null, url: string})=>{


    const {breadcrumb_history, current_name, url} = props;

    const currentUrl = location.pathname + location.search;
    const newHistory = [
                 
    ...breadcrumb_history,
    ...(current_name ? [{name: current_name, url: currentUrl}] : []),
                 
    ];
    const path = url;
    
    return newPath(path, {history: JSON.stringify(newHistory)});
}